import React, { forwardRef, memo } from 'react';
import cls from 'clsx';
import styles from './button.module.css';
import { IButtonProps } from './Button.types';
import { Loading } from '@/assets';

const Button = forwardRef<HTMLButtonElement, IButtonProps>(
  (
    {
      children,
      color = 'standard',
      size = 'large',
      loading = false,
      type = 'button',
      disabled = false,
      className = '',
      ...rest
    }: IButtonProps,
    ref
  ) => {
    const disableState = React.useMemo(
      () => disabled || loading,
      [disabled, loading]
    );
    return (
      <button
        ref={ref}
        type={type}
        disabled={disableState}
        className={cls(
          styles.button,
          styles[size],
          { [styles[color]]: !disableState },
          className
        )}
        {...rest}
      >
        {loading && <Loading className={styles.icon} />}
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default memo(Button);
